import _ from 'lodash';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface NodeMenuStore {
  menuOpen: boolean;
  anchorEl: any | null;

  sourceNodeId: string | null;
  sourceNodeHeight: number | null;
  sourceNodePosition: { x: number; y: number } | null;

  handleOpenMenu(
    el: any,
    nodeId?: string,
    position?: { x: number; y: number },
    height?: number,
  ): () => void;

  handleCloseMenu(): void;
}

const useTopNodeMenuStore = createWithEqualityFn<NodeMenuStore>(
  (set) => ({
    menuOpen: false,
    anchorEl: null,
    sourceNodeId: null,
    sourceNodeHeight: null,
    sourceNodePosition: null,

    handleOpenMenu(el: any, nodeId?: string, position?: { x: number; y: number }, height?: number) {
      return () => {
        set(() => ({
          menuOpen: true,
          anchorEl: el,
          sourceNodeId: !_.isNil(nodeId) ? nodeId : null,
          sourceNodeHeight: !_.isNil(height) ? height : null,
          sourceNodePosition: !_.isNil(position) ? position : null,
        }));
      };
    },

    handleCloseMenu() {
      set(() => ({ menuOpen: false, anchorEl: null, sourceNodeId: null, sourceNodeHeight: null, sourceNodePosition: null }));
    },
  }),
  shallow
);

export default useTopNodeMenuStore;
